import axios from '@/lib/AxApi';

export default {
    async selectToday(params)
    {
        try
        {
            const response = await axios.get('/Events/selectToday',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async getStatistics(params)
    {
        try
        {
            const response = await axios.get('/Events/getStatistics',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/Events/selectRow',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async submitData(params)
    {
        try
        {
            let func = 'insertRow';
            if (typeof params.id !== 'undefined' && params.id !== '')
            {
                func = 'updateRow';
            }

            const response = await axios.post(`/Events/${func}`, params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async duplicateCalendar(params)
    {
        try
        {
            const response = await axios.post('/Events/duplicateCalendar', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/Events/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
};
